import { Component, ViewEncapsulation, Input, HostBinding, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';

import { FastLaneItems } from '../../../../fastlane/models/fastlane-datacenter-config';
import { UNDERSCORE } from '../../../utils/constant';
import { formatDimension } from '../../../utils/number.format';
import { NumberPipe } from '../../../pipes/number.pipe';

interface DisplayedFastlaneItems {
	id: string;
	quantity?: number | undefined;
	status: string;
	steelGrade: string;
	supplierRfqNumber: string;
	dimension: string;

}

@Component({
	selector: 'copo-result-fastlane-card',
	templateUrl: './result-card-fastlane.component.html',
	styleUrl: './result-card-fastlane.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		MatRippleModule,
		RouterLink,
		MatTooltipModule,
		TranslateModule,
		NumberPipe,
	],
})
export class ResultCardFastLaneComponent implements OnInit {
	@HostBinding('class.passthrough') readonly passthrough = true;

	@Input() fastlane!: FastLaneItems;
	displayedFastlaneItems!: DisplayedFastlaneItems;

	readonly underscore = UNDERSCORE;

	ngOnInit() {
		const { fastlane } = this;

		this.displayedFastlaneItems = {
			id: fastlane.id,
			quantity: fastlane.requestedQuantity,
			status: fastlane.prototypeStatusDescription,
			steelGrade: fastlane.requestedSteelGrade,
			supplierRfqNumber: fastlane.supplierRfqNumber,
			dimension: formatDimension(
				fastlane.thickness,
				fastlane.width,
				fastlane.length || undefined
			),
		};
	}
}
